import { render, staticRenderFns } from "./GerenciarCursos.vue?vue&type=template&id=2110ce46&scoped=true&"
import script from "./GerenciarCursos.vue?vue&type=script&lang=js&"
export * from "./GerenciarCursos.vue?vue&type=script&lang=js&"
import style0 from "./GerenciarCursos.vue?vue&type=style&index=0&id=2110ce46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2110ce46",
  null
  
)

export default component.exports